function initializeAnimations() {
  // Intersection Observer for scroll animations
  const animateOnScrollElements = document.querySelectorAll(
    "main [data-animation], .main-header [data-animation], .main-footer-dark [data-animation]",
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const animationType = element.dataset.animation;
          const delay = parseInt(element.dataset.delay) || 0;

          setTimeout(() => {
            element.classList.remove("animate-hidden"); // Remove initial hidden state
            element.classList.add("animated", animationType);
          }, delay);

          // Stop observing once animated
          observer.unobserve(element);
        }
      });
    },
    {
      threshold: 0.1, // Trigger when 10% of the element is visible
    },
  );

  animateOnScrollElements.forEach((el) => {
    // Add a class to hide elements initially, before animation
    el.classList.add("animate-hidden");
    observer.observe(el);
  });

  // Initial Page Load Animations (for elements immediately visible)
  const initialLoadElements = document.querySelectorAll(
    "main [data-animation]",
  );
  initialLoadElements.forEach((el, index) => {
    // Exclude elements that are handled by the IntersectionObserver for on-scroll animations
    // or elements that are part of the hero section (handled by landing.js)
    if (!el.closest(".hero-content")) {
      // Exclude hero content
      const animationType = el.dataset.animation;
      const delay = parseInt(el.dataset.delay) || index * 150; // Increased stagger delay

      el.classList.add("animate-hidden"); // Ensure hidden initially

      setTimeout(() => {
        el.classList.remove("animate-hidden");
        el.classList.add("animated", animationType);
      }, delay);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeAnimations();
});

window.initializeAnimations = initializeAnimations;
